import React, { useEffect, useState } from 'react';
import { useTranslation } from "react-i18next";
import { ModalComp, KeyLamp } from "../";
import { WidgetCommands, ScheduleList, WidgetSetting, EditWidget, MoveWidget, InfoWidget, DeviceInfo, LearnWidget } from "./";
import { FaEyeSlash, FaEye, FaQuestion } from "react-icons/fa";

const WidgetRadio = ({ zone, isPhone, show, sendWidgetCommand, health, showAll, setShowFreezing }) => {
    const { t } = useTranslation();
    const [openKeyLampModal, setOpenKeyLampModal] = useState(false);
    const toggleKeyLamp = () => {
        setOpenKeyLampModal(!openKeyLampModal);
    }
    const openKeyLamp = () => {
        if (isPhone && window.orientation === 0) {
            toggleKeyLamp();
        } else {
            show("keyLamp");
        }
    }
    const [widgetSettingOpen, setWidgetSettingOpen] = useState(false);
    const toggleWidgetSetting = () => setWidgetSettingOpen(!widgetSettingOpen);
    const [openCommandsModal, setOpenCommandsModal] = useState(false);
    const toggleCommands = () => setOpenCommandsModal(!openCommandsModal);
    const [openEditModal, setOpenEditModal] = useState(false);
    const toggleEdit = () => setOpenEditModal(!openEditModal);
    const [openMoveModal, setOpenMoveModal] = useState(false);
    const toggleMove = () => setOpenMoveModal(!openMoveModal);
    const [openScheduleListModal, setOpenScheduleListModal] = useState(false);
    const toggleScheduleList = () => setOpenScheduleListModal(!openScheduleListModal);
    const [openInfoModal, setOpenInfoModal] = useState(false);
    const toggleInfo = () => setOpenInfoModal(!openInfoModal);
    const [openDeviceInfoModal, setOpenDeviceInfoModal] = useState(false);
    const toggleDeviceInfo = () => setOpenDeviceInfoModal(!openDeviceInfoModal);
    const [openLearnModal, setOpenLearnModal] = useState(false);
    const toggleLearn = () => setOpenLearnModal(!openLearnModal);

    // تابع ارسال فرمان با کلیک روی آیکون
    const sendCommand = () => {
        var sp = document.getElementById(`${zone.uid}span${zone.index}`)?.classList;
        if (sp && sp.contains('successBorder')) {
            setShowFreezing(true);
            var command = zone.commands[0]?.command + zone.commands[0]?.argument;
            sendWidgetCommand(command, zone.uid);
            setTimeout(() => {
                setShowFreezing(false);
            }, 1000);
        }
    }

    // بررسی وضعیت ویجت (روشن/خاموش) بر اساس کلاس‌های DOM
    useEffect(() => {
        const checkAndUpdateClasses = () => {
            const element = document.getElementById(`${zone.uid}index${zone.index}`);
            if (!element) return;
            
            // بررسی آنلاین بودن دستگاه
            const span = document.getElementById(`${zone.uid}span${zone.index}`);
            if (span) {
                const spClassList = span.classList;
                if (spClassList.contains('successBorder')) {
                    // دستگاه آنلاین
                    element.classList.remove('device-off');
                    element.classList.add('device-on');
                    // برای رادیو، رنگ سبز پیش‌فرض (مصرف کم)
                    // element.classList.add('widget-power-low');
                    // رنگ دور ویجت رادیو
                } else if (spClassList.contains('dangerBorder')) {
                    // دستگاه آفلاین
                    element.classList.remove('device-on');
                    element.classList.add('device-off');
                    element.classList.remove('widget-power-low', 'widget-power-medium', 'widget-power-high');
                }
            }
        };
        
        checkAndUpdateClasses();
        
        // نظارت بر تغییرات کلاس
        const observer = new MutationObserver(() => {
            checkAndUpdateClasses();
        });
        
        const targetNode = document.getElementById(`${zone.uid}span${zone.index}`);
        if (targetNode) {
            observer.observe(targetNode, { attributes: true });
        }
        
        return () => observer.disconnect();
    }, [zone.uid, zone.index]);

    return (
        <>
            <ModalComp
                modal={openKeyLampModal}
                toggle={toggleKeyLamp}
                component={<KeyLamp />}
            />
            <ModalComp
                modal={openCommandsModal}
                toggle={toggleCommands}
                component={<WidgetCommands zone={zone} />}
            />
            <ModalComp
                modal={openScheduleListModal}
                toggle={toggleScheduleList}
                component={<ScheduleList zone={zone} />}
            />
            <ModalComp
                modal={openEditModal}
                toggle={toggleEdit}
                component={<EditWidget zone={zone} toggleEdit={toggleEdit} />}
            />
            <ModalComp
                modal={openMoveModal}
                toggle={toggleMove}
                component={<MoveWidget zone={zone} toggleMove={toggleMove} />}
            />
            <ModalComp
                modal={openInfoModal}
                toggle={toggleInfo}
                component={<InfoWidget zone={zone} toggleInfo={toggleInfo} />}
            />
            <ModalComp
                modal={openDeviceInfoModal}
                toggle={toggleDeviceInfo}
                component={<DeviceInfo toggleDeviceInfo={toggleDeviceInfo} />}
            />
            <ModalComp
                modal={openLearnModal}
                toggle={toggleLearn}
                component={<LearnWidget sendWidgetCommand={sendWidgetCommand} zone={zone} toggleLearn={toggleLearn} />}
            />
            <ModalComp
                modal={widgetSettingOpen}
                toggle={toggleWidgetSetting}
                component={<WidgetSetting zone={zone}
                    toggleCommands={toggleCommands}
                    toggleScheduleList={toggleScheduleList}
                    toggleEdit={toggleEdit}
                    toggleInfo={toggleInfo}
                    toggleLearn={toggleLearn}
                    toggleDeviceInfo={toggleDeviceInfo}
                    toggleMove={toggleMove} />}
                dark={true}
            />
            <div className={`device w-100 p-3 device-off`} id={`${zone.uid}index${zone.index}`}>
                <div className="d-flex align-items-center justify-content-between">
                    {/* آیکون ویجت - با کلیک فرمان ارسال می‌شود */}
                    <i
                        onClick={sendCommand}
                        id={`${zone.uid}span${zone.index}`}
                        className={`deviceCircle dangerBorder d-flex align-items-center cursor justify-content-center text-center 
                        ${zone.serial === health.serial && (health.health[zone.index] === 1 || health.health[zone.index] === 2) ? 'bg-activeDevice text-white' : 'bg-deactiveDevice text-dark'} 
                        ${zone.uid}`}
                        style={{ cursor: 'pointer' }}
                    >
                        {zone.property[2] !== 'image_path' ?
                            <img src={zone.property[2]} className="w-75" alt="device" />
                            :
                            <FaQuestion />
                        }
                    </i>
                    {showAll && zone.property[3] === '0' ?
                        <FaEyeSlash />
                        :
                        showAll && zone.property[3] === '1' ?
                            <FaEye />
                            :
                            ''
                    }
                </div>
                <div className="fn widgets pt-2">
                    <b className="m-0 fn12" onClick={openKeyLamp}>{zone.caption}</b>
                </div>
                {zone.commands[1]?.didactic === true ?
                    <small className="fn10 d-block pb-1 pt-2">{t("نیازمند لرن")}</small>
                    :
                    <small
                        id={`${zone.uid}text${zone.index}`}
                        className="fn10 d-block pb-1 pt-2"
                    >
                        {t("لرن شده")}
                    </small>
                }
                <div>
                    <i
                        className="icon-ellipsis-vert p-1 detailIconRotate cursor"
                        onClick={toggleWidgetSetting}
                    />
                </div>
            </div>
        </>
    );
};

export { WidgetRadio };